import React from "react";

import TimeslotRuleItem from "./TimeslotRuleItem";
import {
  TimeslotRuleMediaSelect,
  TimeslotRuleSingleCountSelect,
} from "./TimeslotRuleItemSelect";
import { TimeslotColumns } from "../../../types";

import type { JSX } from "react";
import type { ConnectDragSource } from "react-dnd";

import type { TimeslotRule } from "../../../api/FastAPI.types";

interface TimeslotRuleSpecificProps {
  rule: TimeslotRule;
  onClickDelete: (uuid: string) => void;
  isDragging: boolean;
  isDragDisabled: boolean;
  dragRef: ConnectDragSource;
}

function TimeslotRuleSpecific({
  rule,
  onClickDelete,
  isDragging,
  dragRef,
  isDragDisabled,
}: TimeslotRuleSpecificProps): JSX.Element {
  const columns = {
    [TimeslotColumns.Rank]: rule.rank,
    [TimeslotColumns.Mode]: rule.mode,
    [TimeslotColumns.Source]: <TimeslotRuleMediaSelect ruleId={rule.uuid} />,
    [TimeslotColumns.Count]: <TimeslotRuleSingleCountSelect />,
  };
  return (
    <TimeslotRuleItem
      columns={columns}
      dragRef={dragRef}
      isDragDisabled={isDragDisabled}
      isDragging={isDragging}
      onClickDelete={onClickDelete}
      uuid={rule.uuid}
    />
  );
}

export default TimeslotRuleSpecific;
